<template>
  <AppView class="language">
    <p v-if="showInfo" class="language__info">Not your language? Please choose:</p>

    <ul class="language__items">
      <li class="language__item" v-for="(item, index) in items" :key="index">
        <a href="#" class="language__link" @click.prevent="changeLanguage(item.code)">
          {{ item.name }} <img :src="item.icon" />
        </a>
      </li>
    </ul>
  </AppView>
</template>

<script>
import AppView from '@/components/AppView.vue';

export default {
  name: 'Language',
  components: {
    AppView,
  },

  data() {
    return {
      showInfo: this.$route.query.showInfo === 'true',
      items: [
        // { name: 'PL', code: 'pl', icon: require('@/assets/flag-pl.png') },
        // { name: 'BG', code: 'bg', icon: require('@/assets/flag-bg.png') },
        { name: 'CZ', code: 'cz', icon: require('@/assets/flag-cz.png') },
        { name: 'HU', code: 'hu', icon: require('@/assets/flag-hu.png') },
        { name: 'RO', code: 'ro', icon: require('@/assets/flag-ro.png') },
      ],
    };
  },

  methods: {
    changeLanguage(code) {
      this.$i18n.locale = code;

      localStorage.setItem('PP2021:locale', JSON.stringify(code));

      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss">
.language {
  &__info {
    margin-bottom: 20px;
    text-align: center;
  }

  &__items {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }

  &__item {
    margin: 15px;
    padding: 25px 50px 25px 60px;

    background-color: #0e76bc;

    transform: skewX(-20deg);
    transform-origin: bottom left;

  }

  &__link {
    position: relative;
    padding-right: 70px;
    display: block;
    font-size: 26px;
    font-weight: bold;
    text-decoration: none;
    text-transform: uppercase;
    color: inherit;

    transform: skewX(20deg);
    transform-origin: bottom left;

    img {
      position: absolute;
      right: 0;
      top: 50%;
      width: 50px;

      transform: translateY(-50%);
    }

    &:hover {
      color: #ffff00;
    }
  }
}
</style>
